import React, { useState } from 'react';

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
  const faqs = [
    {
      question: "What services does Ramwin Technology offer?",
      answer: "We provide custom web and mobile application development, website design with SEO optimization, comprehensive software testing and quality assurance, and professional IT training programs. Our solutions are designed to help businesses reduce costs, improve efficiency, and accelerate growth."
    },
    {
      question: "How can your software testing services benefit my organization?",
      answer: "Our global testing partnerships help organizations launch products faster with fewer bugs, improve user satisfaction, and reduce post-launch maintenance costs. We provide both manual and automated testing services tailored to your specific needs."
    },
    {
      question: "What training programs are available?",
      answer: "We offer hands-on training in software testing (manual and automated), full-stack web development (ASP.NET, C#, SQL Server, React, Angular), and modern development practices. All programs are led by industry experts with 15+ years of experience and focus on practical, immediately applicable skills."
    },
    {
      question: "Do you offer internship opportunities?",
      answer: "Yes, we offer internship programs for BTech, BCA, and MCA students. Interns work on real projects and gain valuable industry experience. All candidates must complete our interview process to ensure the best fit for both parties."
    }
  ];
  
  return (
    <section id="faq" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-8">
          <h2 className="text-sm font-semibold text-blue-400 uppercase tracking-wider mb-2">F.A.Q</h2>
          <p className="text-3xl md:text-4xl font-bold text-white">Frequently Asked Questions</p>
        </div>
        
        <div className="mt-12 max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="mb-4 dark-card rounded-xl overflow-hidden transition-all duration-300 relative z-10"
            >
              <button
                className={`w-full p-6 text-left font-semibold flex justify-between items-center transition-colors duration-200 ${
                  activeIndex === index ? 'bg-blue-500 bg-opacity-20 text-blue-300' : 'text-white hover:bg-slate-800 hover:bg-opacity-50'
                }`}
                onClick={() => toggleAccordion(index)}
              >
                <span className="text-lg">{index + 1}. {faq.question}</span>
                <span className={`text-2xl font-bold transition-transform duration-300 ${
                  activeIndex === index ? 'text-blue-400 rotate-180' : 'text-blue-400'
                }`}>
                  ▼
                </span>
              </button>
              
              <div 
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  activeIndex === index ? 'max-h-96 pb-6' : 'max-h-0'
                }`}
              >
                <p className="text-gray-300 leading-relaxed pt-2">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;